import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import * as me from '../../me'
import * as routeBound from '../../route-bound'

import { Api } from './api.service'
import * as excel from './excel'
import * as plugins from './plugins'
import type { TypeParams } from './types'

// TODO: need more comments explaining what's happening

@ngCore.Injectable()
export class Collection extends ec.Collection<TypeParams> {
  constructor() {
    const meFeature = ngCore.inject(me.Feature)
    super({
      api: ngCore.inject(Api),
      context$: ngCore.inject(routeBound.scenario.Context.TOKEN),
      identify: report => report.label.id,
      name: ec.Name.Predefined.RateReport,
      // offlineQueryFilterFn: ({ label }, { searchTerm }) =>
      //   searchTerm
      //     ? Object.values({
      //         categoryId: label.faFunctionCategorization?.categoryId,
      //         code: label.code,
      //         name: label.name,
      //         purpose: ents.extra.rate.Report.Purpose.of(label.id),
      //       })
      //         .filter(value => !!value)
      //         .join('.')
      //         .toLowerCase()
      //         .includes(searchTerm.toLowerCase())
      //     : true,
      // offlineQuerySortFn({ label: a }, { label: b }, sort) {
      //   {
      //     if (!sort) {
      //       // No sorting
      //       return 0
      //     }
      //     const isReportLabelKey = (
      //       entity: ents.extra.rate.Report.Label,
      //       key: string,
      //     ): key is keyof ents.extra.rate.Report.Label => key in entity

      //     const aVal = isReportLabelKey(a, sort.by) ? a[sort.by] ?? '' : ''
      //     const bVal = isReportLabelKey(b, sort.by) ? b[sort.by] ?? '' : ''

      //     const baseDir = !ec.models.QueryRequest.Sort.Helpers.WithDefaults.from(
      //       sort,
      //     ).descending
      //       ? -1
      //       : 1
      //     return aVal < bVal ? baseDir : aVal > bVal ? -baseDir : 0
      //   }
      // },
      plugins: {
        additionalFactories: [
          new plugins.content.Factory(),
          new excel.Factory({ meFeature }),
          new ds.table.ec.Factory<TypeParams>(collection => ({
            rowConfig: ({ entity }) => ({
              onClick: () => {
                const source = 'ReportList.Table.Row.Clicked'

                collection.plugins
                  .lookup(plugins.content.Plugin)
                  .get()
                  .feature.actions.display.from(source)
                  .dispatch({ id: entity.label.id })
              },
            }),
            search: true,
          })),
        ],
        dataOperation: {
          // NOTE When getting list of reports from API, only report labels are retrieved without content
          // Use cache if report content is loaded, otherwise retrieve from API
          useCacheInsteadOfApi: ({ content }) => !!content,
        },
      },
    })
  }
}
